import { render, staticRenderFns } from "./sjfx.vue?vue&type=template&id=0507b093"
import script from "./sjfx.vue?vue&type=script&lang=js"
export * from "./sjfx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports